module.exports = "/_next/static/images/d6a9a629f39ec0df016bc164a4088336-cuenta-ric.svg.webp";